import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-af-common-library',
  template: `
    <p>
      af-common-library works!
    </p>
  `,
  styles: [
  ]
})
export class AfCommonLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
